import api from '../service/api.service';

import { parseQueryFilters } from '../../helpers/parseQueryFilters';
import {
  AttyFeesConfigResponse,
  PaginationQueryParams,
  PaymentPreviewData,
  SaveAttyFeesConfigData,
  SettlementAttyFeesResponse,
  UpdateSettlementAttyFeesPayload,
} from '../../types';
import { CaseAttorneyFeesConfigProps } from '../../views/CasesView/types';

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/v3/cases`;
const BASE_URL_NEW = `${process.env.REACT_APP_BASE_API_URL}/v5/cases`;


export const getCaseFeesConfig = async (caseId: number, settlementId?: number) => {
  const targetUrl = `${BASE_URL_NEW}/${caseId}/atty-fees-config`;

  return await api.get<AttyFeesConfigResponse>(targetUrl, {
    params: settlementId != null ? { settlementId } : undefined,
  });
};

export const updateCaseFeesConfig = async (caseId: number, data: CaseAttorneyFeesConfigProps ) => {
  const targetUrl = `${BASE_URL_NEW}/${caseId}/atty-fees-config`;

  return await api.put<AttyFeesConfigResponse>(targetUrl, data);
};

export const calculatePaymentPreview = async (caseId: number, data: SaveAttyFeesConfigData) => {
  const targetUrl = `${BASE_URL}/${caseId}/atty-fees-config/payment-preview-by-config`;

  return await api.post<PaymentPreviewData>(targetUrl, data);
};

export const getPaymentPreview = async (caseId: number) => {
  const targetUrl = `${BASE_URL}/${caseId}/atty-fees-config/payment-preview`;

  return await api.get<PaymentPreviewData>(targetUrl);
};

export const getSettlementAttyFees = async (settlementId: number) => {
  const targetUrl = `v1/fo/settlements/${settlementId}/atty-fees`;

  return await api.get<SettlementAttyFeesResponse>(targetUrl);
};

export const updateSettlementAttyFees = async (
  settlementId: number,
  data: UpdateSettlementAttyFeesPayload,
) => {
  const targetUrl = `v1/fo/settlements/${settlementId}/atty-fees`;

  return await api.put<void>(targetUrl, data);
};

export const getCounselEntities = async ({
  size,
  page,
  match,
  filters,
}: PaginationQueryParams) => {
  const queryFilters = parseQueryFilters(filters);
  const targetUrl = `/v1/cases/counsel-entities?size=${size}&page=${page}&match=${match || ''}${queryFilters || ''}`;

  return await api.get(targetUrl);
};
